import React from 'react';
import Navigation from './Navigation';
import { userRequest, isNotEmpty, signupCall, loginCall, updateUser } from "../util/user";
import socks from '../images/main1.jpg';
import logo from '../images/new_logo.svg';
import poop_5 from '../images/main1.jpg';
import SignUp from "./accounts/SignUp";
import Login from "./accounts/Login";
import Forgot from "./accounts/Forgot";
import { Link, withRouter } from 'react-router-dom';

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
      user: this.props.user,
      UserForm: this.props.user || {},
      userContext: "Login",
      step: 0
    }

    this.changeUserContext = this.changeUserContext.bind(this);
    this.changeUserContextToForgot = this.changeUserContextToForgot.bind(this);
    this.updateStep = this.updateStep.bind(this);
    this.backStep = this.backStep.bind(this);
    this.goToHome = this.goToHome.bind(this);
    this.setUserContext = this.setUserContext.bind(this);
    this.setUser = this.setUser.bind(this);
  }

  updateStep() {
    this.setState({
      step: this.state.step + 1
    });
  }

  goToHome() {
    const url = `/`;
    this.props.history.push(url);
  }

  backStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  setUserContext(state) {
    const value = state || "Login";

    this.setState({
      userContext: value
    });
  }

  setUser(user) {
    const value = user || (this.state.user || this.props.user);
    const state = this;

    this.setState({
      user: value
    }, () => {
      state.props.updateUserForRoutes(value)
    });
  }

  finishProfile() {
    const state = this;

    updateUser(this.props.user, this).then((user) => {
      state.setState({user: user});
    });
  }

  changeUserContextToForgot() {
    this.setState({
      step: 0,
      userContext: "Forgot"
    });
  }

  changeUserContext() {
    if (this.state.userContext == "Login") {
      this.setState({
        step: 0,
        userContext: "Signup"
      });
    } else if (this.state.userContext == "Your Account") {
      this.setState({
        step: 0,
        userContext: "Signup"
      });
    } else {
      this.setState({
        step: 0,
        userContext: "Login"
      });
    }
  }

  render() {
    let userConditional;
    let user = this.state.user || this.props.user;
    let userContext = this.state.userContext;

    if (user && user.user && user.user.email && this.state.ignoreState !== true) {
      userContext = "Your Account";
    }

    if (!isNotEmpty(user) && (userContext == "Your Account" || userContext == "New User") && this.state.ignoreState !== true) {
      userContext = "Login"
    }

    if (userContext == "Signup") {
      userConditional = <SignUp backStep={this.backStep} setUserContext={this.setUserContext} setUser={this.setUser} changeUserContext={this.changeUserContext}/>
    } else {
      userConditional = <Login
        setUserContext={this.setUserContext}
        setUser={this.setUser}
        changeUserContext={this.changeUserContext}
        changeUserContextToForgot={this.changeUserContextToForgot}
        />
    }

    if (userContext == "Forgot") {
      userConditional = <Forgot
        setUserContext={this.setUserContext}
        setUser={this.setUser}
        changeUserContext={this.changeUserContext} />
    }

    // if (userContext == "Your Account") {
    //   this.goToHome();
    //   return (<div></div>)
    // }

    return (
      <div className="form account-form">
        {userConditional}
      </div>
    )
  }
}

export default withRouter(Account);
